import React from 'react';

import Accordion from 'components/practice/charts/ClinicalNote/shared/Accordion';
import Skeleton from 'components/shared/Skeleton/Skeleton';

const FormLoading = () => {
  return (
    <Accordion disabled title={<Skeleton containerClassName="w-40 block" height={30} />}>
      <div className="grid grid-cols-2 gap-4">
        <Skeleton containerClassName="col-span-2" />
        <Skeleton />
        <Skeleton />
        <Skeleton containerClassName="col-span-2" height={208} />
        <Skeleton containerClassName="col-span-2" />
        <Skeleton height={208} />
        <Skeleton height={208} />
        <Skeleton containerClassName="col-span-2" height={72} />
        <Skeleton containerClassName="col-span-2" height={24} />
        <div className="flex gap-2">
          <div className="flex w-full gap-2">
            <Skeleton containerClassName="w-[24px]" circle height={24} />
            <Skeleton height={24} containerClassName="w-full" />
          </div>
          <div className="flex w-full gap-2">
            <Skeleton containerClassName="w-[24px]" circle height={24} />
            <Skeleton height={24} containerClassName="w-full" />
          </div>
        </div>
        <div className="flex gap-2">
          <div className="flex w-full gap-2">
            <Skeleton containerClassName="w-[24px]" circle height={24} />
            <Skeleton height={24} containerClassName="w-full" />
          </div>
          <div className="flex w-full gap-2">
            <Skeleton containerClassName="w-[24px]" circle height={24} />
            <Skeleton height={24} containerClassName="w-full" />
          </div>
        </div>
        <div className="flex gap-2">
          <div className="flex w-full gap-2">
            <Skeleton containerClassName="w-[24px]" circle height={24} />
            <Skeleton height={24} containerClassName="w-full" />
          </div>
          <div className="flex w-full gap-2">
            <Skeleton containerClassName="w-[24px]" circle height={24} />
            <Skeleton height={24} containerClassName="w-full" />
          </div>
        </div>
        <div className="flex gap-2">
          <div className="flex w-full gap-2">
            <Skeleton containerClassName="w-[24px]" circle height={24} />
            <Skeleton height={24} containerClassName="w-full" />
          </div>
          <div className="flex w-full gap-2">
            <Skeleton containerClassName="w-[24px]" circle height={24} />
            <Skeleton height={24} containerClassName="w-full" />
          </div>
        </div>
        <Skeleton containerClassName="col-span-2" height={104} />
      </div>
    </Accordion>
  );
};

export default FormLoading;
